import { loading } from "@/core/src";
import { Controller } from "@hotwired/stimulus";
import { dispatchUnexpectedErrorOccurred } from "../../events/erroroccurred";
import { dispatchErrorsCleared } from "../../events/errorscleared";
import { parseJsonResponse } from "../../http_helpers";
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.bank = null;
    }
    get form() {
        if (this.formTarget instanceof HTMLFormElement) {
            return this.formTarget;
        }
        throw new Error("No compatible 'form' target specified.");
    }
    // form handling
    setUpForm(event) {
        this.cancelButtonTarget.classList.remove(this.hiddenClass);
        const form = this.form;
        form.reset();
        this.bank = event.detail;
        form.elements["bank[id]"].value = this.bank.id.toString();
        form.elements["bank[name]"].value = this.bank.name;
        if (form.elements["bank[withLogo]"]) {
            form.elements["bank[withLogo]"].checked = this.bank.logo !== null;
        }
        this.displayLogoPicker();
    }
    cancelUpdate() {
        this.resetForm();
        this.dispatch("updateCancelled");
    }
    resetForm() {
        this.cancelButtonTarget.classList.add(this.hiddenClass);
        this.form.reset();
        this.bank = null;
        this.displayLogoPicker();
    }
    async handleSubmit(event) {
        event.preventDefault();
        console.log("submitting");
        const form = this.form;
        // logo is valid if:
        // - bank[withLogo] is not checked, in which case, no logo will be sent
        // when bank is not null (is updating)
        // - bank.logo is not null or bank[logo] is not empty
        // when bank is null
        // - bank[logo] is not empty
        let isLogoValid = false;
        if (form.elements["bank[withLogo]"] &&
            form.elements["bank[withLogo]"].checked) {
            if (this.bank === null || this.bank.logo === null) {
                if (form.elements["bank[logo]"] && form.elements["bank[logo]"].value) {
                    isLogoValid = true;
                }
                else {
                    isLogoValid = false;
                }
            }
            else {
                isLogoValid = true;
            }
        }
        else {
            this.clearLogo();
            isLogoValid = true;
        }
        if (form.elements["bank[logo]"]) {
            form.elements["bank[logo]"].setCustomValidity("");
            if (!isLogoValid) {
                form.elements["bank[logo]"].setCustomValidity("Si se marca para agregar logo, se debe seleccionar una imágen para el logo.");
                form.reportValidity();
                return;
            }
        }
        const postUrl = this.bank === null ? this.createUrlValue : this.updateUrlValue;
        const body = new FormData(form);
        if (form.elements["bank[withLogo]"] &&
            form.elements["bank[withLogo]"].checked &&
            form.elements["bank[logo]"] &&
            !form.elements["bank[logo]"].value &&
            this.bank &&
            this.bank.logo !== null) {
            body.append("bank[b64Logo]", this.bank.logo);
        }
        const prepareSubmit = () => {
            dispatchErrorsCleared(this);
            this.submitterTarget.disabled = true;
            const loadingDone = loading(this.submitterTarget, "Enviando...");
            return () => {
                this.submitterTarget.disabled = false;
                loadingDone();
            };
        };
        const done = prepareSubmit();
        let response;
        try {
            response = await parseJsonResponse(this, await window.fetch(postUrl, {
                method: "POST",
                body,
            }));
        }
        catch (error) {
            dispatchUnexpectedErrorOccurred(this, error);
            return;
        }
        finally {
            done();
        }
        // parsing failed if undefined is "returned"
        if (typeof response === "undefined") {
            return;
        }
        // all good?
        if (this.bank === null) {
            this.resetForm();
        }
        this.dispatch("dataHasChanged", { prefix: "", detail: this.bank || undefined });
    }
    async confirmDelete(event) {
        const { bank, initiator } = event.detail;
        initiator.disabled = true;
        if (!window.confirm(`¿Desea realmente eliminar el banco "${bank.name}"? Esta acción no se puede revertir.`)) {
            initiator.disabled = false;
            return;
        }
        const prepareDelete = () => {
            dispatchErrorsCleared(this);
            const loadingDone = loading(initiator, "Eliminando...");
            return () => {
                initiator.disabled = false;
                loadingDone();
            };
        };
        const done = prepareDelete();
        let response;
        try {
            response = parseJsonResponse(this, await window.fetch(this.deleteUrlValue, {
                method: "POST",
                body: new URLSearchParams({ id: bank.id.toString() }),
            }));
        }
        catch (error) {
            dispatchUnexpectedErrorOccurred(this, error);
            return;
        }
        finally {
            done();
        }
        this.dispatch("dataHasChanged", { prefix: "" });
    }
    // misc utils
    trim(event) {
        if (event.target instanceof HTMLInputElement) {
            event.target.value = event.target.value.trim();
        }
    }
    displayLogoPicker() {
        const form = this.form;
        const shown = form.elements["bank[withLogo]"] && form.elements["bank[withLogo]"].checked;
        this.logoPickerElementTargets.forEach((e) => e.classList[shown ? "remove" : "add"](this.hiddenClass));
        if (!shown) {
            this.clearLogo();
        }
    }
    clearLogo() {
        const form = this.form;
        if (form.elements["bank[logo]"]) {
            form.elements["bank[logo]"].value = "";
            form.elements["bank[logo]"].dispatchEvent(new Event("change"));
        }
    }
}
default_1.classes = ["hidden"];
default_1.targets = ["form", "submitter", "cancelButton", "logoPickerElement"];
default_1.values = {
    createUrl: String,
    updateUrl: String,
    deleteUrl: String,
};
//# sourceMappingURL=main_controller.js.map